/**
 * Misc useful pointers for object pooling.
 */
var EMPTY_OBJECT = {};
var EMPTY_ARRAY = [];
var TYPE_INFERENCE_OBJECT = {
    OBJECT_EXISTS_FOR_TYPE_INFERENCE_PURPOSES_ONLY: null,
};
export { EMPTY_ARRAY, EMPTY_OBJECT, TYPE_INFERENCE_OBJECT };
//# sourceMappingURL=Pointers.js.map